import { Link } from "react-router-dom";
import { useSiteCopy } from "../../context/SiteCopyContext";
import { CopyText } from "../CopyText";
import { getAtPath } from "../../lib/siteCopyPaths";

export function HomePartnerCta() {
  const { copy } = useSiteCopy();
  return (
    <section className="section home-partner-cta">
      <div className="home-partner-strip">
        <div className="home-partner-text">
          <div className="sec-eyebrow">
            <em>
              <CopyText path="home.partnerCta.eyebrow" as="span" />
            </em>
          </div>
          <h2 className="sec-title sec-title-sm">
            <CopyText path="home.partnerCta.title" as="span" />
          </h2>
          <p style={{ opacity: 0.78, maxWidth: 540 }}>
            <CopyText path="home.partnerCta.body" as="span" />
          </p>
        </div>
        <div className="home-partner-actions">
          <Link to="/partner" className="btn btn-primary">
            {String(getAtPath(copy, "home.partnerCta.ctaPrimary") ?? "")}{" "}
            <span className="arr">→</span>
          </Link>
          <Link to="/contact" className="btn btn-ghost">
            {String(getAtPath(copy, "home.partnerCta.ctaGhost") ?? "")}
          </Link>
        </div>
      </div>
    </section>
  );
}
